export default __webpack_public_path__ + "static/media/gordita-black.beef8dcf.woff";